import { spawn } from 'redux-saga/effects';

import servicesSagas from './services/servicesSagas';
import { sagas as relatedSagas } from './relatedModule';

export default function* sagas() {
	yield spawn(relatedSagas);
	yield spawn(servicesSagas);
}
